import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Slider from "react-slick";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import GalleryPageIamge from "../assets/img/GalleryPageIamge.jpg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { motion } from "framer-motion";
import Fancybox2 from "../components/Fancybox2";
import barbieCakeZeppoli from "../assets/img/coverImageGallery/barbieCakeZeppoli.jpg";
import makeupCakeZeppoli from "../assets/img/coverImageGallery/makeupCakeZeppoli.jpg";
import babyShowerCakeZeppoli from "../assets/img/coverImageGallery/babyshowerCakeZeppoli.jpg";
import lettersCakeZeppoli from "../assets/img/coverImageGallery/lettersCakeZeppoli.jpg";
import sportsCakeZeppoli from "../assets/img/coverImageGallery/sportsCakeZeppoli.jpg";
import cartoonCakeTwo from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeTwo.png";
import cartoonCakeThree from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeThree.png";
import cartoonCakeFour from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeFour.png";
import cartoonCakeFive from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeFive.png";
import cartoonCakeSix from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeSix.png";
import cartoonCakeSeven from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeSeven.png";
import cartoonCakeEight from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeEight.png";
import cartoonCakeNine from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeNine.png";
import cartoonCakeTen from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeTen.png";
import cartoonCakeEleven from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeEleven.png";
import cartoonCakeTwelve from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeTwelve.png";
import cartoonCakeThirteen from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeThirteen.png";
import cartoonCakeFourteen from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeFourteen.png";
import cartoonCakeFifteen from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeFifteen.png";
import cartoonCakeSixteen from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeSixteen.png";
import cartoonCakeSeventeen from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeSeventeen.png";
import cartoonCakeEighteen from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeEighteen.png";
import cartoonCakeNineteen from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeNineteen.png";
import cartoonCakeTwenty from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeTwenty.png";
import cartoonCakeTwentyOne from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeTwentyOne.png";
import cartoonCakeTwentyTwo from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeTwentyTwo.png";
import cartoonCakeTwentyThree from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeTwentyThree.png";
import cartoonCakeTwentyFour from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeTwentyFour.png";
import cartoonCakeTwentyFive from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeTwentyFive.png";
import cartoonCakeTwentySix from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeTwentySix.png";
import cartoonCakeTwentySeven from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeTwentySeven.png";
import cartoonCakeTwentyEight from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeTwentyEight.png";
import cartoonCakeTwentyNine from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeTwentyNine.png";
import cartoonCakeThirty from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeThirty.png";
import cartoonCakeThirtyOne from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeThirtyOne.png";
import cartoonCakeThirtyTwo from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeThirtyTwo.png";
import cartoonCakeThirtyThree from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeThirtyThree.png";
import cartoonCakeThirtyFour from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeThirtyFour.png";
import cartoonCakeThirtyFive from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeThirtyFive.png";
import cartoonCakeThirtySix from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeThirtySix.png";
import cartoonCakeThirtySeven from "../assets/img/cakeImagesGallery/cartoon/cartoonCakeThirtySeven.png";

function CartoonCakeGallery() {
  useEffect(() => {
    document.title = "Zeppoli Bakers | Gallery | Cartoon Cake";
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, []);

  const directorsSliderSettings = {
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    cssEase: "linear",
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  // for fancy box
  const opts = {
    fullScreen: {
      autoStart: true, // Auto-start in full-screen mode
    },
    Thumbs: false,
  };

  // for gallery filters
  const allCards = [
    {
      category: "Cake",
      image: cartoonCakeSix,
      id: 1,
    },
    {
      category: "Cake",
      image: cartoonCakeTwo,
      id: 2,
    },
    {
      category: "Cake",
      image: cartoonCakeThree,
      id: 3,
    },
    {
      category: "Cake",
      image: cartoonCakeFour,
      id: 4,
    },
    {
      category: "Cake",
      image: cartoonCakeFive,
      id: 5,
    },
    {
      category: "Cake",
      image: cartoonCakeSeven,
      id: 6,
    },
    {
      category: "Cake",
      image: cartoonCakeEight,
      id: 7,
    },
    {
      category: "Cake",
      image: cartoonCakeNine,
      id: 8,
    },
    {
      category: "Cake",
      image: cartoonCakeTen,
      id: 9,
    },
    {
      category: "Cake",
      image: cartoonCakeEleven,
      id: 10,
    },
    {
      category: "Cake",
      image: cartoonCakeTwelve,
      id: 11,
    },
    {
      category: "Cake",
      image: cartoonCakeThirteen,
      id: 12,
    },
    {
      category: "Cake",
      image: cartoonCakeFourteen,
      id: 13,
    },
    {
      category: "Cake",
      image: cartoonCakeFifteen,
      id: 14,
    },
    {
      category: "Cake",
      image: cartoonCakeSixteen,
      id: 15,
    },
    {
      category: "Cake",
      image: cartoonCakeSeventeen,
      id: 16,
    },
    {
      category: "Cake",
      image: cartoonCakeEighteen,
      id: 17,
    },
    {
      category: "Cake",
      image: cartoonCakeNineteen,
      id: 18,
    },
    {
      category: "Cake",
      image: cartoonCakeTwenty,
      id: 19,
    },
    {
      category: "Cake",
      image: cartoonCakeTwentyOne,
      id: 20,
    },
    {
      category: "Cake",
      image: cartoonCakeTwentyTwo,
      id: 21,
    },
    {
      category: "Cake",
      image: cartoonCakeTwentyThree,
      id: 22,
    },
    {
      category: "Cake",
      image: cartoonCakeTwentyFour,
      id: 23,
    },
    {
      category: "Cake",
      image: cartoonCakeTwentyFive,
      id: 24,
    },
    {
      category: "Cake",
      image: cartoonCakeTwentySix,
      id: 25,
    },
    {
      category: "Cake",
      image: cartoonCakeTwentySeven,
      id: 26,
    },
    {
      category: "Cake",
      image: cartoonCakeTwentyEight,
      id: 27,
    },
    {
      category: "Cake",
      image: cartoonCakeTwentyNine,
      id: 28,
    },
    {
      category: "Cake",
      image: cartoonCakeThirty,
      id: 29,
    },
    {
      category: "Cake",
      image: cartoonCakeThirtyOne,
      id: 30,
    },
    {
      category: "Cake",
      image: cartoonCakeThirtyTwo,
      id: 31,
    },
    {
      category: "Cake",
      image: cartoonCakeThirtyThree,
      id: 32,
    },
    {
      category: "Cake",
      image: cartoonCakeThirtyFour,
      id: 33,
    },
    {
      category: "Cake",
      image: cartoonCakeThirtyFive,
      id: 34,
    },
    {
      category: "Cake",
      image: cartoonCakeThirtySix,
      id: 35,
    },
    {
      category: "Cake",
      image: cartoonCakeThirtySeven,
      id: 36,
    },
  ];

  // for animation begin
  const [screenSize, setScreenSize] = useState(window.innerWidth);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 100);

    // Cleanup timeout if the component unmounts
    return () => clearTimeout(timer);
  }, []);
  // upside animation
  const variants5 = {
    hidden: { opacity: 0, y: 100 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        type: "spring",
        stiffness: 50,
        damping: 20,
      },
    }),
  };
  // for animation end

  return (
    <>
      <Navbar />

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={variants5}
      >
        <div className="breadcumb-wrapper " data-bg-src={GalleryPageIamge}>
          <div
            className="container z-index-common"
            style={{ marginTop: "150px" }}
          >
            <div className="breadcumb-content">
              <h1 className="breadcumb-title text-white">Gallery</h1>
              <ul className="breadcumb-menu">
                <li>
                  <Link className="text-white" to="/">
                    Home
                  </Link>
                </li>
                <li className="text-white">Gallery</li>
                <li className="text-white">Cartoon Cake</li>
              </ul>
            </div>
          </div>
        </div>
      </motion.div>

      <section className="space">
        <div className="container">
          {isVisible && (
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true }}
              variants={variants5}
            >
              <div className="title-area text-center">
                <span className="sub-title">Cake Gallery</span>
                <h2 className="sec-title">Our Latest Cartoon Cake</h2>
              </div>
            </motion.div>
          )}

          <div className="row gy-40 filter-active">
            {allCards.map((card) => (
              <div
                className={`col-xl-3 col-lg-4 col-sm-6 filter-item`}
                key={card.id}
              >
                {isVisible && (
                  <motion.div
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={variants5}
                  >
                    <div className="th-product product_style1">
                      <div
                        style={{
                          borderRadius: "12px",
                          height: "365px",
                        }}
                        className="mx-15"
                      >
                        <LazyLoadImage
                          alt="Zeppoli cartoon cake image"
                          effect="blur"
                          wrapperProps={{
                            style: { transitionDelay: "1s" },
                          }}
                          src={card.image}
                          placeholderSrc={card.image}
                          style={{
                            borderRadius: "12px",
                            width: "270px",
                          }}
                        />
                      </div>
                    </div>
                  </motion.div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {isVisible && (
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={variants5}
        >
          <div className="title-area text-center">
            <h2 className="sec-title">Explore More Categories</h2>
          </div>

          <div className="container">
            <div className="px-lg-4 px-3 my-5">
              <Fancybox2 options={opts}>
                <Slider
                  {...directorsSliderSettings}
                >
                  <div>
                    <div className="gallery-card mx-2">
                      <div
                        className="gallery-img"
                        style={{ borderRadius: "12px" }}
                      >
                        <LazyLoadImage
                          alt="Gallery One Zeppoli"
                          effect="blur"
                          wrapperProps={{
                            style: { transitionDelay: "1s" },
                          }}
                          src={barbieCakeZeppoli}
                          placeholderSrc={barbieCakeZeppoli}
                          width={"310px"}
                          style={{ borderRadius: "12px" }}
                        />
                      </div>
                      <div
                        className="gallery-content"
                        style={{ borderRadius: "12px" }}
                      >
                        <Link
                          to="/barbiecakegallery"
                          className="icon-btn popup-img"
                        >
                          <i className="fas fa-eye"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="gallery-card mx-2">
                      <div
                        className="gallery-img"
                        style={{ borderRadius: "12px" }}
                      >
                        <LazyLoadImage
                          alt="Gallery Two Zeppoli"
                          effect="blur"
                          wrapperProps={{
                            style: { transitionDelay: "1s" },
                          }}
                          src={makeupCakeZeppoli}
                          placeholderSrc={makeupCakeZeppoli}
                          width={"310px"}
                          style={{ borderRadius: "12px" }}
                        />
                      </div>
                      <div
                        className="gallery-content"
                        style={{ borderRadius: "12px" }}
                      >
                        <Link
                          to="/makeupcakegallery"
                          className="icon-btn popup-img"
                        >
                          <i className="fas fa-eye"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="gallery-card mx-2">
                      <div
                        className="gallery-img"
                        style={{ borderRadius: "12px" }}
                      >
                        <LazyLoadImage
                          alt="Gallery Three Zeppoli"
                          effect="blur"
                          wrapperProps={{
                            style: { transitionDelay: "1s" },
                          }}
                          src={babyShowerCakeZeppoli}
                          placeholderSrc={babyShowerCakeZeppoli}
                          width={"310px"}
                          style={{ borderRadius: "12px" }}
                        />
                      </div>
                      <div
                        className="gallery-content"
                        style={{ borderRadius: "12px" }}
                      >
                        <Link
                          to="/babyshowercakegallery"
                          className="icon-btn popup-img"
                        >
                          <i className="fas fa-eye"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="gallery-card mx-2">
                      <div
                        className="gallery-img"
                        style={{ borderRadius: "12px" }}
                      >
                        <LazyLoadImage
                          alt="Gallery Four Zeppoli"
                          effect="blur"
                          wrapperProps={{
                            style: { transitionDelay: "1s" },
                          }}
                          src={sportsCakeZeppoli}
                          placeholderSrc={sportsCakeZeppoli}
                          width={"310px"}
                          style={{ borderRadius: "12px" }}
                        />
                      </div>
                      <div
                        className="gallery-content"
                        style={{ borderRadius: "12px" }}
                      >
                        <Link
                          to="/sportscakegallery"
                          className="icon-btn popup-img"
                        >
                          <i className="fas fa-eye"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className="gallery-card mx-2">
                      <div
                        className="gallery-img"
                        style={{ borderRadius: "12px" }}
                      >
                        <LazyLoadImage
                          alt="Gallery Five Zeppoli"
                          effect="blur"
                          wrapperProps={{
                            style: { transitionDelay: "1s" },
                          }}
                          src={lettersCakeZeppoli}
                          placeholderSrc={lettersCakeZeppoli}
                          width={"310px"}
                          style={{ borderRadius: "12px" }}
                        />
                      </div>
                      <div
                        className="gallery-content"
                        style={{ borderRadius: "12px" }}
                      >
                        <Link
                          to="/letterscakegallery"
                          className="icon-btn popup-img"
                        >
                          <i className="fas fa-eye"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </Slider>
              </Fancybox2>
            </div>
          </div>
        </motion.div>
      )}

      <Footer />
    </>
  );
}

export default CartoonCakeGallery;
